import Chart from 'chart.js/auto';
const chartjs = require('../../../../../../components/chart/chartjs');
const math = require('../../../../../../js-handler/math');

function buildTreemapDataFromRows(rows) {
    if (!Array.isArray(rows) || rows.length === 0) return null;
    const out = [];
    for (const row of rows) {
        if (!row || row.id === 'nothing') continue;
        const qty = parseFloat(row.available);
        const q = Number.isFinite(qty) ? qty : 0;
        const totalNum = parseFloat(row.amount.replace(/[^0-9.-]/g, ''));
        const name = row.name || row.code || 'Item';
        const brand = row.brand ? String(row.brand).trim() : '';
        const fullName = brand ? `${row.name} ${brand}`.trim() : name;
        const codePart = row.code ? ` (${row.code})` : '';
        const value = Math.max(totalNum, q, 0.01);
        
        out.push({
            name,
            value: value,
            fullName: fullName + codePart,
            qty: q,
            inventoryTotal: math.cashFormat(totalNum),
            inventoryTotalFormatted: math.cashFormat(totalNum),
        });
    }
    return out.length ? out : null;
}

export function createTreemapChart(rowsOrEmpty) {
    const chartContainer = document.querySelector('.card-chart');
    if (!chartContainer) return;

    chartContainer.innerHTML = '<canvas class="chartjs" id="itemTreemapChart"></canvas>';
    const canvas = document.getElementById('itemTreemapChart');

    const existingChart = Chart.getChart(canvas);
    if (existingChart) {
        existingChart.destroy();
    }
    
    const fromApi = buildTreemapDataFromRows(rowsOrEmpty);
    const data = fromApi || [
        // opcional: dejar demo mínima si no hay datos
        { name: '—', value: 1, fullName: 'Sin datos', qty: 0, inventoryTotal: 0, inventoryTotalFormatted: '0.00' },
    ];
    chartjs.start({
        elem: 'treemap',
        act: 'createSimple',
        targetChart: { html: canvas },
        data: data,
        options: {
            responsive: true,
            aspectRatio: false,
            aspectRatio: 10 / 10,
            
        }
    });
}